export const CustomDataEnum = {
  TrafficData: [
    { key: 1, value: "User Defined" },
    { key: 2, value: "Auto-MAX" },
  ],
  FrameSize: [
    { key: 0, value: 64 },
    { key: 1, value: 128 },
    { key: 2, value: 256 },
    { key: 3, value: 512 },
    { key: 4, value: 1024 },
    { key: 5, value: 1518 },
    { key: 6, value: 10000 },
    { key: 7, value: 218 },
  ],
  FrameFill: [
    { key: 0, value: "Fixed" },
    { key: 1, value: "Random" },
  ],
  LossLimit: [
    { key: 9, value: "IEEE 802.3* (Quick)" },
    { key: 10, value: "IEEE 802.3" },
    { key: 8, value: "Custom" },
  ],
  ExpectedLineRate: [
    { key: 0, value: "100M" },
    { key: 1, value: "1G" },
    { key: 2, value: "2.5G" },
    { key: 3, value: "5G" },
    { key: 4, value: "10G" },
    { key: 5, value: "Any" },
  ],
  FullTrafficData: [
    { key: 0, value: "Application" },
    { key: 1, value: "User Defined" },
    { key: 2, value: "Auto-MAX" },
  ],
  Definition: [
    { key: 0, value: "SD", IRM: 4.5, MaxStreams: 2200 },
    { key: 1, value: "HD", IRM: 13, MaxStreams: 760 },
    { key: 2, value: "UHD", IRM: 32, MaxStreams: 310 },
  ],
  Codec: [
    { key: 0, value: "H.264" },
    { key: 1, value: "H.265" },
    { key: 2, value: "MJPEG" },
  ],
  Resolution: [
    {
      key: 0,
      value: "VGA",
      Codec: [
        { key: 0, value: "H.264", IRM: 1.87, MaxCameras: 5300 },
        { key: 1, value: "H.265", IRM: 0.93, MaxCameras: 10700 },
        { key: 2, value: "MJPEG", IRM: 10.5, MaxCameras: 950 },
      ],
    },
    {
      key: 1,
      value: "720p",
      Codec: [
        { key: 0, value: "H.264", IRM: 5.61, MaxCameras: 1750 },
        { key: 1, value: "H.265", IRM: 2.8, MaxCameras: 3500 },
        { key: 2, value: "MJPEG", IRM: 31.5, MaxCameras: 310 },
      ],
    },
    {
      key: 2,
      value: "1080p",
      Codec: [
        { key: 0, value: "H.264", IRM: 12.6, MaxCameras: 790 },
        { key: 1, value: "H.265", IRM: 6.36, MaxCameras: 1550 },
        { key: 2, value: "MJPEG", IRM: 70.8, MaxCameras: 140 },
      ],
    },
    {
      key: 3,
      value: "3MP",
      Codec: [
        { key: 0, value: "H.264", IRM: 19.1, MaxCameras: 520 },
        { key: 1, value: "H.265", IRM: 10, MaxCameras: 990 },
        { key: 2, value: "MJPEG", IRM: 107, MaxCameras: 90 },
      ],
    },
    {
      key: 4,
      value: "5MP",
      Codec: [
        { key: 0, value: "H.264", IRM: 29.9, MaxCameras: 330 },
        { key: 1, value: "H.265", IRM: 15, MaxCameras: 660 },
        { key: 2, value: "MJPEG", IRM: 168, MaxCameras: 55 },
      ],
    },
    {
      key: 5,
      value: "8MP",
      Codec: [
        { key: 0, value: "H.264", IRM: 63.3, MaxCameras: 155 },
        { key: 1, value: "H.265", IRM: 31.7, MaxCameras: 310 },
        { key: 2, value: "MJPEG", IRM: "NA", MaxCameras: "NA" },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/subtestsetting/customdata/customenum.js